export const Tags = {
    GOOGLE_TAG_MANAGER: 'GOOGLE_TAG_MANAGER',
    FACEBOOK_PIXEL: 'FACEBOOK_PIXEL'
}